// @ts-nocheck
import objectKeys from "@store/Framework/Common/Utilities/objectKeys";
import { SimpleQuoteFormFieldValues } from "@store/Framework/Store/Greif/Components/SimpleQuoteForm/SimpleQuoteFormState";
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";
import isEqual from "lodash/isEqual";

type HandlerType = Handler<Partial<SimpleQuoteFormFieldValues>>;

export const DispatchSetDraftFieldValuesIfNeeded: HandlerType = props => {
    const { formDraftFieldValues } = props.getState().greif.components.simpleQuoteForm;

    if (!objectKeys(props.parameter)?.some(x => !isEqual(props.parameter[x], formDraftFieldValues[x]))) {
        return;
    }

    props.dispatch({
        type: "Greif/Components/SimpleQuoteForm/SetDraftFieldValues",
        parameter: props.parameter,
    });
};

export const chain = [DispatchSetDraftFieldValuesIfNeeded];

const setDraftFieldValues = createHandlerChainRunner(chain, "SetDraftFieldValues");

export default setDraftFieldValues;
